// extracted by mini-css-extract-plugin
module.exports = {"FormLabel":"FormLabel_FormLabel__h7eRk"};